import { MutationHookOptions } from '@apollo/client'
import { TrainingClassMembershipsDatatableDocument } from 'generated/resources/datatable.graphql'
import {
  CreateTrainingClassMembershipsDocument,
  CreateTrainingClassMembershipsMutation,
  CreateTrainingClassMembershipsMutationVariables,
  SelectorClassMembershipsDocument,
  TrainingClassMembershipsDataCollectionDocument,
  TrainingClassMembershipsDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type Options = MutationHookOptions<
  CreateTrainingClassMembershipsMutation,
  CreateTrainingClassMembershipsMutationVariables
>

export const useCreateTrainingClassMembership = (options?: Options) => {
  const [bulkCreateTrainingClassMemberships, { loading }] = useMutation(
    CreateTrainingClassMembershipsDocument,
    {
      ...options,
      extractorFn: (data) => data.trainingsMutations.bulkCreateTrainingsTrainingClassMembership,
    }
  )

  return {
    loading,
    createTrainingClassMemberships(variables: CreateTrainingClassMembershipsMutationVariables) {
      return bulkCreateTrainingClassMemberships({
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [
          TrainingClassMembershipsDatatableDocument,
          SelectorClassMembershipsDocument,
          TrainingClassMembershipsDocument,
          'TrainingMembershipsDataTable',
          TrainingClassMembershipsDataCollectionDocument,
        ],
      })
    },
  }
}
